import { store } from "../../store";
import { findProductFront } from "./findProductFront";
import { buildSpecificationConfiguration } from "./buildSpecificationConfiguration";
import { findSpecificationById } from "./findSpecificationById";
import { clearPriceOnProductPage, updatePriceOnProductPage } from "../updatePriceOnProductPage";

/**
 * @param {number[]} frontIds
 * @param {ProductFront[]} productData
 */
export const preselectConfiguratorItems = async (frontIds, productData) => {
	if (!store.state.selectedProduct) {
		const productFront = findProductFront(productData, store.state.baseProps.specificationId);

		if (!productFront) {
			return;
		}

		store.commit("SET_SELECTED_PRODUCT", productFront);
	}

	const specification = findSpecificationById(
		store.state.selectedProduct.specifications,
		store.state.baseProps.specificationId);

	if (!specification) {
		return;
	}

	const preselectedQuantity = store.state.baseProps.preselectedQuantity;
	if (preselectedQuantity) {
		specification.amount = preselectedQuantity;
	}

	clearPriceOnProductPage();

	store.commit("SET_CONFIGURATOR_TYPE", "configuration");

	const configuration = buildSpecificationConfiguration(store.state.selectedProduct, specification);

	store.state.baseProps.isConfiguration = true;

	store.commit("SET_EXISTING_CONFIGURATION_DATA", configuration);
	store.commit("SET_EXISTING_CONFIGURATION_SELECTED");

	if (hasOnlyOffsetPrices(specification)) {
		setOffsetPrice();
	}

	const unwatch = store.watch(
		state => state.configurator.steps.all,
		steps => {
			const firstOptionStep = steps.find(step => step.groupId);
			if (firstOptionStep) {
				store.commit("SET_STEP_ACTIVE", firstOptionStep);
				unwatch();
			}
		},
		{ immediate: true }
	);

	store.watch(
		(_, getters) => getters.getPrice,
		price => {
			const isRushPrice = store.getters.getOrderLine.isRush;
			updatePriceOnProductPage(price, isRushPrice);
		});
};

const hasOnlyOffsetPrices = specification => {
	const amountList = store.state.selectedProduct.amountList;
	return (!amountList || !amountList.length || amountList === "0")
		&& specification.offsetPricings
		&& specification.offsetPricings.length > 0;
};

const setOffsetPrice = async () => {
	await store.dispatch("_getOffsetPriceTable");

	const offsetPrices = store.getters.getOffsetPriceTable.sort((a, b) => a.Amount - b.Amount);

	store.commit("SET_OFFSET_SELECTED", true);
	store.commit("SET_ORDERLINE_AMOUNT", offsetPrices[0].Amount);
	store.commit("SET_CONFIGURATION_OFFSET_PRICE", offsetPrices[0].Amount);
};



// WEBPACK FOOTER //
// ./src/helpers/specification/preselectConfiguratorItems.js